import { createAsyncThunk } from '@reduxjs/toolkit';
import getCredentials from '../../utils/getCredentials';
import { useSelector } from 'react-redux';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import getCurrentUserOrientationData from 'scenes/ProjectForms/utils/getCurrentUserOrientationData';

export const loadCurrentUserOrientationData = createAsyncThunk(
    'projectForm/loadCurrentUserOrientationData',
    async (_, { getState }) => {
        const { accessKeyId, secretAccessKey, sessionToken } =
            await getCredentials();

        const selectedProjectId = selectSelectedProjectId(getState());

        const params = {
            accessKeyId,
            secretAccessKey,
            sessionToken,
        };

        const data = await getCurrentUserOrientationData(selectedProjectId, params);
        // console.log('🚀 ~ data:', data);
        return {
            data,
        }
    }
);